import { Icon, type IconName } from "../../icons";
import { useModuleActionsSlot } from "../ModuleActionsSlot/ModuleActionsSlot";
import { type SectionTab, SectionTabs } from "../SectionTabs/SectionTabs";

export interface ModuleHeaderProps {
  icon: IconName;
  title: string;
  description?: string;
  tabs: SectionTab[];
  active?: string;
  onNavigate?: (href: string) => void;
}

/** Top of every module page: icon + module name + description, then its sections as tabs (only when there are two or more: one tab has nowhere to switch to). */
export function ModuleHeader({ icon, title, description, tabs, active, onNavigate }: ModuleHeaderProps): React.JSX.Element {
  const slot = useModuleActionsSlot();
  return (
    <div className="nb-modhead">
      <div className="nb-modhead-top">
        <span className="nb-module-icon nb-modhead-icon" aria-hidden="true">
          <Icon name={icon} />
        </span>
        <div className="nb-modhead-text">
          <p className="nb-modhead-title">{title}</p>
          {description ? <p className="nb-modhead-desc">{description}</p> : null}
        </div>
        {/* The page's main buttons land here (see PageHead `titleHidden`). */}
        <div className="nb-modhead-actions" ref={slot?.[1]} />
      </div>
      {tabs.length > 1 ? <SectionTabs items={tabs} active={active} onNavigate={onNavigate} ariaLabel={`${title} sections`} /> : null}
    </div>
  );
}
